<template>
  <info-section-table :fields="fields" :data="data">
    <template v-slot:header>
      <h4 class="blue-text">{{L10n('quote')}}</h4>
    </template>
    <template v-slot:cell-chosen="{ row }">
      <span class="icon-db" :class="{'is-false': !row.chosen, 'is-true': row.chosen}"></span>
    </template>
    <template v-slot:cell-price="{ row }">
      {{row.price | toPriceCurrency(dataSourceCurrency.map[row.currencyID] && dataSourceCurrency.map[row.currencyID].title)}}
    </template>
    <template v-slot:cell-conditionID="{ row }">
      {{dataSourceCondition.map[row.conditionID] && dataSourceCondition.map[row.conditionID].title}}
    </template>
    <template v-slot></template>
    <template v-slot:row-controls="{ row }">
      <slot name="controls" :row="row">
      </slot>
    </template>
  </info-section-table>
</template>

<script>
export default {
  name: 'InfoStep',
  components: {
    'info-section-table': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Table.vue')
  },
  props: {
    data: { type: Array },
    fieldList: { type: Array }
  },
  data () {
    return {
      defaultFields: [
        { title: this.L10n('chosen'), fieldName: 'chosen' },
        { title: this.L10n('part-number'), fieldName: 'partNumber' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('price'), fieldName: 'price' }
      ]
    }
  },
  computed: {
    fields () {
      return this.fieldList || this.defaultFields
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  }
}
</script>
